import type { ReactNode } from "react";

interface HeroRootProps {
  children: Readonly<ReactNode>;
  wide?: boolean;
  reverse?: boolean;
}

export default function HeroRoot({ children }: HeroRootProps) {
  return (
    <section className="relative">    
    {children}
    </section>
  );
}
